import React from "react";
import PropTypes from "prop-types";
import Checkbox from "~/assets/js/components/Forms/Checkbox";
import i18n from "i18next";

const DeliveryInstructionsForm = ({ handleChange, formValues }) => {
    return (
        <form
            id="delivery-instructions-form"
            className="pottsalat-form checkbox-group"
        >
            <div>
                <Checkbox
                    bindName="contactless_delivery"
                    onChange={(e) =>
                        handleChange({ contactless_delivery: e.target.checked })
                    }
                    label={i18n.t(
                        "overview.deliveryInstructions.contactlessDelivery"
                    )}
                    value={formValues.contactless_delivery}
                />
                <Checkbox
                    bindName="no_doorbell"
                    onChange={(e) =>
                        handleChange({ no_doorbell: e.target.checked })
                    }
                    label={i18n.t("overview.deliveryInstructions.noDoorbell")}
                    value={formValues.no_doorbell}
                />
            </div>
            <div>
                <Checkbox
                    bindName="delivery_phone_call"
                    onChange={(e) =>
                        handleChange({ delivery_phone_call: e.target.checked })
                    }
                    label={i18n.t(
                        "overview.deliveryInstructions.deliveryPhoneCall"
                    )}
                    value={formValues.delivery_phone_call}
                />
                <Checkbox
                    bindName="give_porter"
                    onChange={(e) =>
                        handleChange({ give_porter: e.target.checked })
                    }
                    label={i18n.t("overview.deliveryInstructions.givePorter")}
                    value={formValues.give_porter}
                />
            </div>
        </form>
    );
};

DeliveryInstructionsForm.propTypes = {
    handleChange: PropTypes.func,
    isLoading: PropTypes.bool,
    formValues: PropTypes.shape({
        no_doorbell: PropTypes.bool,
        delivery_phone_call: PropTypes.bool,
        give_porter: PropTypes.bool,
        contactless_delivery: PropTypes.bool,
    }),
};

export default DeliveryInstructionsForm;
